import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { EventsService } from "./services/events.service";
import { WindowService } from "./services/window.service";
import { ConfigurationLoader } from "./services/configuration.loader";
import { Logger } from "./utils/logger";
import { AppComponent } from './app.component';
import { routing } from './app.routing';

import { IntroComponent } from './intro/intro.component';
import { ConfiguratorComponent } from "./configurator/configurator.component";
import { ProductImage } from "./canvas/product-image.component";
import { SubProductImage } from "./canvas/subproduct-image.component";
import { CanvasImage } from "./canvas/canvas-image.component";
import { CanvasPanel } from './canvas'
import { ProductDetailPanel } from "./product_detail/product_detail.component";
import { FilterPanel } from "./filter_panel/filter_panel.component";
import { PriceBage } from "./price_bage/price_bage.component";
import { SideBar } from "./sidebar/sidebar.component";
import { TotalpricePanel } from "./price_total/total_price.panel.component";
import { EmailBox } from "./popups/email_box.component";
import { LinkBox } from "./popups/link_box.component";
import { PageLoader } from "./loader/loader.component";
import { SuccessEmailBox } from "./popups/success_email_box.component";
import { ProductComponent } from "./sidebar/product.component";
import { SubProductComponent } from "./sidebar/subproduct.component";
import { SubProductTabComponent } from "./sidebar/subproduct_tab.component";
import { SubProductAlternativeComponent } from "./sidebar/subproduct_alternative.component";
import { FilterTabComponent } from "./filter_panel/filter_tab.component";
import { FilterTabContentComponent } from "./filter_panel/filter_tab_content.component";

import { ReplaceBreakes } from "./pipes/replace.breakes";

import { TranslateModule, TranslateService, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { LocalTranslateService } from "./services/local_translate.service";

export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http, "i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    IntroComponent,
    ConfiguratorComponent,
    SideBar,
    TotalpricePanel,
    PageLoader,
    ProductDetailPanel,
    FilterPanel,
    PriceBage,
    CanvasPanel,
    EmailBox,
    LinkBox,
    ProductImage,
    SubProductImage,
    CanvasImage,
    SuccessEmailBox,
    ProductComponent,
    SubProductComponent,
    SubProductTabComponent,
    SubProductAlternativeComponent,
    FilterTabComponent,
    FilterTabContentComponent,
    ReplaceBreakes
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    routing,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    })
  ],
  providers: [
    EventsService,
    WindowService,
    ConfigurationLoader,
    Logger,
    TranslateService,
    LocalTranslateService,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts